import RestoreUserRequestModelBase from '../_generated/modelBases/restore-user-request-model-base';

export default class RestoreUserRequestModel extends RestoreUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
